import { ModelConceptHierarchy } from 'src/containers/ProjectDiagram/types/data';
import { Model } from 'src/containers/ProjectDiagram/types/model';
import { getLabelKeyFromHierarchyKey } from 'src/containers/ProjectDiagram/utils/modelConceptHierarchy/createModelConceptHierarchyLabel';

// Note: use of this function should always be followed up with
// cleanupModelConceptHierarchyMappings in the same commit
// to the diagram model
export const removeModelConceptHierarchy =
  (data: ModelConceptHierarchy) => (model: Model) => {
    const labelKey = getLabelKeyFromHierarchyKey(data.key);
    const labelData = model.nodeDataArray.find(
      (existing) => existing.key === labelKey
    );

    if (labelData) {
      model.removeNodeData(labelData);
    }

    model.removeLinkData(data);
  };
